import { BulkOperationType, BulkReviewRow } from '@ps/survey-utils';
import { BasePayloadMapper, Nullable } from '@ps/utils';
import { match } from 'ts-pattern';
import {
  SurveyPatchPayloadDto,
  LaunchTrafficChannelRequestDto,
  GroupSurveysRequestDto,
} from '../dtos/survey.dto';

interface BulkPatchPayloadMap {
  toPayload(row: BulkReviewRow): SurveyPatchPayloadDto[];
}

export class BulkPatchCpiPayloadMapper
  extends BasePayloadMapper<BulkReviewRow, SurveyPatchPayloadDto[]>
  implements BulkPatchPayloadMap
{
  public toPayload(row: BulkReviewRow): SurveyPatchPayloadDto[] {
    return [
      {
        op: 'replace',
        path: '/offer_price',
        value: Number(row['updatedValue']),
      },
    ];
  }
}

export class BulkPatchBillingPayloadMapper
  extends BasePayloadMapper<BulkReviewRow, SurveyPatchPayloadDto[]>
  implements BulkPatchPayloadMap
{
  public toPayload(row: BulkReviewRow): SurveyPatchPayloadDto[] {
    return [
      {
        op: 'replace',
        path: '/billing_id',
        value: String(row['updatedValue']),
      },
    ];
  }
}

export class BulkPatchStatusPayloadMapper
  extends BasePayloadMapper<BulkReviewRow, SurveyPatchPayloadDto[]>
  implements BulkPatchPayloadMap
{
  public toPayload(row: BulkReviewRow): SurveyPatchPayloadDto[] {
    return [
      {
        op: 'replace',
        path: '/ps_survey_status',
        value: row['updatedValue'],
      },
    ];
  }
}

export class BulkPatchMarginPayloadMapper
  extends BasePayloadMapper<BulkReviewRow, SurveyPatchPayloadDto[]>
  implements BulkPatchPayloadMap
{
  public toPayload(row: BulkReviewRow): SurveyPatchPayloadDto[] {
    return [
      {
        op: 'replace',
        path: '/margin',
        value: Number(row['updatedValue']),
      },
    ];
  }
}

export class BulkPatchProjectManagerPayloadMapper
  extends BasePayloadMapper<BulkReviewRow, SurveyPatchPayloadDto[]>
  implements BulkPatchPayloadMap
{
  public toPayload(row: BulkReviewRow): SurveyPatchPayloadDto[] {
    return [
      {
        op: 'replace',
        path: '/bpm',
        value: row['updatedValue'],
      },
    ];
  }
}

export class BulkPatchOperatorProjectManagerPayloadMapper
  extends BasePayloadMapper<BulkReviewRow, SurveyPatchPayloadDto[]>
  implements BulkPatchPayloadMap
{
  public toPayload(row: BulkReviewRow): SurveyPatchPayloadDto[] {
    return [
      {
        op: 'replace',
        path: '/pm',
        value: row['updatedValue'],
      },
    ];
  }
}

export class BulkLaunchTcReplicaPayloadMapper {
  public toPayload(): LaunchTrafficChannelRequestDto {
    return {
      channelSurveyName: 'TC-R_Bulk_Replica',
      channelType: 'REP',
      payload: {},
      qbpQuota: {},
      copyTargetingFromParent: true,
    };
  }
}

export class BulkPatchPayloadMapperFactory {
  public create(operation: BulkOperationType): Nullable<BulkPatchPayloadMap> {
    return match(operation)
      .with('cpi', () => new BulkPatchCpiPayloadMapper())
      .with('billingNumber', () => new BulkPatchBillingPayloadMapper())
      .with('margin', () => new BulkPatchMarginPayloadMapper())
      .with('status', () => new BulkPatchStatusPayloadMapper())
      .with(
        'projectManager',
        'buyerProjectManager',
        () => new BulkPatchProjectManagerPayloadMapper(),
      )
      .with(
        'accountManager',
        () => new BulkPatchOperatorProjectManagerPayloadMapper(),
      )
      .otherwise(() => null);
  }
}

export class BulkGroupSurveysPayloadMapper {
  public toPayload(
    surveyIds: number[],
    groupTitle: string,
  ): GroupSurveysRequestDto {
    return {
      survey_ids: surveyIds,
      group_title: groupTitle,
    };
  }
}
